import DriveHeader from '@/components/DriveHeader.tsx'
import { useParams } from 'react-router-dom'
import DrawingEditor from '@/components/drawing/DrawingEditor.tsx'
import { useDrives } from '@/stores/useDrives.ts'
import { useTranslation } from 'react-i18next'
import useDrawingTemplates from '@/hooks/useDrawingTemplates.tsx'

export default function CardTemplatePage() {
  const { currentDrive } = useDrives()
  const { cardId } = useParams<{cardId: string}>()
  const { t } = useTranslation()
  const drawingTemplates = useDrawingTemplates()

  console.log('cardsId', cardId)
  const cardTemplate = drawingTemplates.find(template => template.id == cardId)!

  return <div className='h-[80vh] flex-1'>
    <DriveHeader description={null} />
    <div className="container mx-auto px-4 flex flex-col gap-3 justify-center overflow-hidden items-center pb-[6rem] h-full bg-red">
      <div className='w-full h-full'>
        <p className='text-center'>{t('common.clickTextToAdapt')}</p>
        <DrawingEditor template={cardTemplate} elementOverrides={{ elements: [
          { elementId: 'qr-code', imgSrc: currentDrive!.qr_code_image || undefined },
            { elementId: 'names-text', text: currentDrive?.title },
          ]}} />
      </div>
    </div>
  </div>
}
